import messages from '../../../locale/messages';
import { inputDescLimit } from '../../../helpers/FieldRestriction';

const validate = values => {
    const errors = {}

    if (values?.description?.length > inputDescLimit) {
        errors.description = messages.cancelReasonExceed;
    }

    return errors
}

export default validate